
    import { Vue,Component } from 'vue-property-decorator'
    import { State,Action,namespace,Mutation } from 'vuex-class'
    import PagedTable from '../../components/common/pagedTable.vue'
    import Partner from '../../components/partner.vue'
    import Outbound from '../../components/outbound.vue'
    import exicon, {defaulticon} from '../../assets/expressicon'
    import dayjs from 'dayjs'
    const packageslist = namespace('packageslist')
    const partner = namespace('partner')
    const site = namespace('site')
    const customer = namespace('customer')
    @Component({
        components: {
            PagedTable,
            Partner,
            Outbound
        }
    })
    export default class Packageslist extends Vue{
        exicon:any = exicon
        defaulticon:any = defaulticon
	    outbounding:boolean = false
        @packageslist.State('pager') pager:any
        @packageslist.State('list') packagesList:any
        @packageslist.State('loading') loading:any
        @partner.State('list') partnerList:any
        @site.State('shelves') shelves:any
        @site.State('info') info:any
        time:any = []
        analysisType:string = '0'
        stockAnalysisData: any = []
        legacyAnalysisData: any = []
        partner:string = '' //查询的快递员
	    sshelf:string = ''
        pachagesInfo:Boolean = false //快递订单详情弹窗
        orderInfo:any = null //快递订单详情
        multipleSelection:any = [] //勾选的项
        searchStatus:string = '' //派件状态
        modifyPartnerStatus:boolean = false //修改快递员弹窗
        stockAnalysis = false
        lookInfoId:string = '' //查看单号详情ID
	    modifyShelfStatus: boolean = false
        changePartnerId:string = '' //修改的快递员id
	    changeShelfId:string = ''
        oldPartnerList:any = [] //修改的旧快递员集合
        changeRowIdList:string = '' //修改的每一项的id集合
        modifyPhoneStatus:boolean = false //修改电话号码弹窗
        changePhoneForm:any = { //改变手机号码提交的参数
            phone:'',
            sendsms:"0"
        }
        changePhoneRules:any = {
            phone: [
                { required: true, message: '请输入正确的电话号码', trigger: 'blur' },
                { min: 11, max: 11, message: '请输入正确的电话号码', trigger: 'blur' }
            ],
            sendsms: [
                { required: true, message: '请选择是否发送短信', trigger: 'blur' }
            ],
        }
        modifyDescStatus:boolean = false //修改备注弹窗
        modifyDescContent:string = '' //修改备注的内容
        modifyCodeStatus:boolean = false //修改快递单号
        modifyCodeContent:string = '' //修改快递单号的单号
        notlist:any = [] //未出库列表
        outboundStatus:boolean = false//未出库列表弹窗
        pachagesInfoLoading:boolean = false
        search:any =  {
                secret: '', //取件码
                code: '', //单号
                phone: '', // 电话
                start: '', //开始日期
                end: '', //结束日期
                status: this.searchStatus, //派件状态
                partner: this.partner, //快递员
                page: 1,
	            shelf: this.sshelf
        }
        get searchQuery() {
            let start = ''
            let end = ''
            if(this.time){
                start = this.time[0]
                end = this.time[1]
            }
            return {
                secret: this.search.secret, //取件码
                code: this.search.code, //单号
                phone: this.search.phone, // 电话
                start: start, //开始日期
                end: end, //结束日期
                status: this.searchStatus, //派件状态
                partner: this.partner, //快递员
                page: this.search.page,
	            shelf: this.sshelf
            }
        }
        get showNano(){
            return this.info.stype === 1;
        }
        get tablecolumn(){
            return [
                {
                    prop: 'index',
                    name: 'index',
                    type: 'slot',
                    label: '#',
                    width: '40px'
                },
                {
                    prop: 'code',
                    name: 'code',
                    type: 'slot',
                    label: '快递单号',
                },
                {
                    prop: 'shelf',
                    name: 'shelf',
                    type: 'slot',
                    label: '货架'
                },
                {
                    prop: 'serial',
                    type: 'text',
                    label: '编号'
                },
                {
                    prop: 'phone',
                    name: 'phone',
                    type: 'slot',
                    width: '120px',
                    label: '电话'
                },
	            {
		            prop: 'name',
		            type: 'text',
		            label: '姓名'
	            },
                {
                    prop: 'partner',
                    name: 'partner',
                    type: 'slot',
                    label: '快递员'
                },
                {
                    prop: 'intime',
                    type: 'text',
                    label: '入库时间'
                },
                {   prop: 'outtime',
                    name: 'outtime',
                    type: 'slot',
                    label: '出库时间'
                },
                {   prop: 'status',
                    name: 'status',
                    type: 'slot',
                    label: '状态'
                },
                {   prop: 'mtype',
                    name: 'mtype',
                    type: 'slot',
                    label: '短信'
                },
                {
                    prop: 'desc',
                    name: 'desc',
                    type: 'slot',
                    label: '备注'
                },
                {
                    prop: 'name',
                    name:'operation',
                    type: 'slot',
                    label: '操作',
                    fixed: 'right',
                }
            ]
        }
        @packageslist.Action('getPackagesList') getPackagesList:any
        @packageslist.Action('getCodeInfo') getCodeInfo:any //获得快递详情
        @packageslist.Action('outbound') outbound:any //出库
        @packageslist.Mutation('changeList') changeList:any //出库改变本地状态
        @packageslist.Action('modifyPartner') modifyPartner:any //修改快递员
        @packageslist.Action('modifyPhone') modifyPhone:any //修改手机号
        @packageslist.Action('modifyDesc') modifyDesc:any //修改备注
        @packageslist.Action('againInbond') againInbond:any //重新入库
        @packageslist.Action('sendRushSms') sendRushSms:any //发送催收短信
        @packageslist.Action('againSendSms') againSendSms:any //重新发送短信
        @packageslist.Action('modifyCode') modifyCode:any //重新发送短信
        @packageslist.Action('modifyShelf') modifyShelf:any
        @packageslist.Action('exportPackagesData') exportPackagesData:any
	    @packageslist.Action('getStockAnalysisData') getStockAnalysisData: any
	    @packageslist.Action('getlegacyAnalysis') getlegacyAnalysis: any;
        @packageslist.Action('outboundSign') outboundSign: any
	    @packageslist.Action('outboundDeparture') outboundDeparture: any
        @partner.Action('getPartnerList') getPartnerList:any
        @packageslist.Action('inboundPachages') inboundPachages:any
        @customer.Action('disCustom') disCustom: any;
        @customer.Action('removeDisCustom') removeDisCustom: any;
	    @site.Action('getShelves') getShelves:any
	    created(){
            this.getList();
            this.getShelves();
        }
        getList(){
            this.getPackagesList(this.searchQuery)
        }
        onSearch(){
	        this.getPackagesList({...this.searchQuery, page: 1})
        }
        // 翻页
        pagechange(e:any){
            this.search.page = e[0].val
            this.getList()
        }
        // 查看快递订单详细信息
        async lookInfo(id:string){
            this.pachagesInfo = true;
            this.lookInfoId = id;
            this.pachagesInfoLoading = true;
            const res = await this.getCodeInfo(id)
	        res.intime = dayjs(res.intime).format('YYYY-MM-DD HH:mm:ss');
	        res.outtime = res.outtime ? dayjs(res.outtime).format('YYYY-MM-DD HH:mm:ss') : '暂无';
            this.orderInfo = res;
            this.pachagesInfoLoading = false;
        }
        // 勾选前面的选项时
        multiplechange(e:any){
            this.multipleSelection = e
            let data = e.map((item:any) => {
                return item._id
            })
            let partner = e.map((item:any) => {
                return item.partner.id
            })
            this.changeRowIdList = data.join(',')
            this.oldPartnerList = partner
        }
        async outboundCommand({command,id}: { command: string, id: string }){
			if(command === 'sign'){
			    await this.outboundSign(id);
			}
            if(command === 'departure'){
                await this.outboundDeparture(id);
            }
            this.getList();
            this.$notify({
                title: '成功',
                message: '出库成功',
                type: 'success'
            });
        }
        // 单个出库
        async outboundOne(data:any,index?:number){
            this.outbounding = true;
            let res;
            if(data.id){
                res = await this.outbound({id:data.id,data:{problem:false}})
            }else{
                res = await this.outbound({id:data})
            }
            if(res){
                this.outbounding = false;
                if(typeof res != 'string'){
                    this.notlist = res
                    if(res.length > 0){
                        this.outboundStatus = true
                    }
                }
                this.playChukuSuccess()
                this.$notify({
                    title: '成功',
                    message: '出库成功',
                    type: 'success'
                });
                if(index){
                    this.changeList(index)
                }else{
                    if(index == 0){
                        this.changeList(index)
                    }else{
                        this.getList()
                    }
                }
            }else{
                this.playChukuFail()
            }
        }
        // 批量出库
        batchInbound(){
            if(this.multipleSelection.length > 0){
                const idList = this.multipleSelection.map((item:any) => item._id)
                this.outboundOne({id:idList.join(','),data:{problem:false}})
            }else{
                this.$message({
                    message: '请选择数据',
                    type: 'warning'
                });
            }
            
        }
        // 打开修改快递员弹窗
        openChangePartner(e:any){
            this.changePartnerId = e.partner.id
            this.modifyPartnerStatus = true
            this.changeRowIdList = e._id
            this.oldPartnerList = [e.partner.id]
        }
        // 修改快递员
        async changePartner(){
            const res = await this.modifyPartner({
                id: this.changeRowIdList,
                data: {
                    oldPartner: this.oldPartnerList,
                    newPatner: this.changePartnerId
                }
            })
            if(res){
                this.$message({ message: '修改成功', type: 'success' });
                this.modifyPartnerStatus = false
                this.getList()
            }
        }
        // 打开修改电话号码弹窗
        openChangePhone(e:any){
            this.modifyPhoneStatus = true
            this.changePhoneForm.phone = e.phone
            this.changeRowIdList = e._id
        }
        // 修改手机号码
        async changePhone(e:any){
            const res = this.modifyPhone({
                id: this.changeRowIdList,
                data:this.changePhoneForm
            })
            if(res){
                this.$message({ message: '修改成功', type: 'success' });
                this.modifyPhoneStatus = false
                this.getList()
	            if(this.changePhoneForm.sendsms === '0'){
		            await this.againSendSms(this.changeRowIdList);
	            }
            }
        }
        // 打开修改备注弹窗
        openChangeDesc(e:any){
            this.modifyDescStatus = true
            this.modifyDescContent = e.desc
            this.changeRowIdList = e._id
        }
        // 修改备注
        changeDesc(){
            const res = this.modifyDesc({
                id: this.changeRowIdList,
                data:{desc: this.modifyDescContent}
            })
            if(res){
                this.$message({ message: '修改成功', type: 'success' });
                this.modifyDescStatus = false
                this.getList()
            }
        }
        // 重新入库
        async againInbondFun(id:string,index?:number){
             this.$confirm('次操作会重新入库, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const res = await this.againInbond(id)
                if(res){
                    this.playRuSuccess()
                    this.$message({ message: '重新入库成功', type: 'success' });
                    this.changeList(index)
                }else{
                    this.playRukuFail()
                }
            })
        }
        async stockAnalysisOpen(){
	        this.stockAnalysis = true;
	        this.nalysisTypeChange();
        }
        async getlegacyAnalysisData(){
	        const res = await this.getlegacyAnalysis();
	        this.legacyAnalysisData = res;
        }
        async searchAnalysis(row){
	        if(this.analysisType === '0'){
                this.searchStatus = '0';
                this.search.phone = row.phone;
	        }
            if(this.analysisType === '1'){
                this.searchStatus = row.query.status;
                this.time = row.query.intime;
            }
            this.stockAnalysis = false;
            this.getList();
        }
        // 打开修改快递单号弹窗
        openChangeCode(e:any){
            this.modifyCodeStatus = true
            this.modifyCodeContent = e.code
            this.changeRowIdList = e._id
        }
        // 修改货架
	    async openChangeShelf(row){
		    this.changeRowIdList = row._id;
		    this.changeShelfId = row.shelf.id;
			this.modifyShelfStatus = true;
	    }
	    changeShelf(){
		    const res = this.modifyShelf({
			    id: this.changeRowIdList,
			    data:{shelf: this.changeShelfId}
		    })
		    if(res){
			    this.$message({ message: '货架修改成功', type: 'success' });
			    this.modifyShelfStatus = false
			    this.getList()
		    }
	    }
        // 修改快递单号
        changeCode(){
            const res = this.modifyCode({
                id: this.changeRowIdList,
                data:{code: this.modifyCodeContent}
            })
            if(res){
                this.$message({ message: '快递单号修改成功', type: 'success' });
                this.modifyCodeStatus = false
                this.getList()
            }
        }
        // 批量出库按钮四个选项选择时
        dropmenu(e:any){
            console.log(e);
            if(e == 'modifypartner'){
                this.modifyPartnerStatus = true
            }else if(e == 'exportexcel'){
                this.exportexcel()
            }else if(e == 'sendrnotice'){
//                this.sendrnotice()
            }else if(e == 'disVerCustom'){
                this.disVerCustom();
            }else if(e == 'removeDisVerCustom'){
                this.removeDisVerCustom();
	        }else{
//	            this.againSendSmsFun()

            }
        }
        // 拉黑隐私面单用户
	    async disVerCustom(){
		    const id = this.multipleSelection[0]._id;
			await this.disCustom({id,reason:'HOME_DELIVERY'});
	    }
	    // 接触拉黑
	    async removeDisVerCustom(){
		    const id = this.multipleSelection[0]._id;
		    await this.removeDisCustom(id);
	    }
        // 重新发送短信
        async againSendSmsFun(){
            const idList = this.multipleSelection.map((item:any) => item._id)
            const res = await this.againSendSms(idList.join(','))
            if(res){
                this.$message({ message: '发送成功', type: 'success' });
            }
        }
        // 发送催收短信
        async sendrnotice(){
            const idList = this.multipleSelection.map((item:any) => item._id)
            const res = await this.sendRushSms(idList.join(','))
            if(res){
                this.$message({ message: '发送成功', type: 'success' });
            }
        }
        // 导出数据
        exportexcel(){
            const data = this.multipleSelection
            if(data.length < 1) return this.$message.error('选择需要导出的数据')
            if(!this.time || !this.time[1] || !this.time[0]) return this.$message.error('请先选择时间段');
            require.ensure([], () => {
                const { export_json_to_excel } = require('../../assets/vendor/Export2Excel');
                const tHeader = ['快递员','单号','电话', '入库时间','出库时间'];
                const p = [tHeader]
                data.map((item:any)=>{
                    p.push([item.partner ? item.partner.name : '未找到',item.code.trim(),item.phone,item.intime,item.outtime])
                })
                const pk = [{
                    sheetName:"派寄件数量统计",
                    data:p
                }];
                const extitle = `派件数据导出-${dayjs(this.time[0]).format("YYYY-MM-DD")}至${dayjs(this.time[1]).format("YYYY-MM-DD")}`
                export_json_to_excel(pk,extitle);
            })
        }
        // 杭州要的导出的数据功能
        async exportexcelHz(){
            if(this.time && this.time.length < 1){
                this.$message({ message: '时间段必须选择', type: 'warning' });
                return
            }
            const token = window.localStorage.getItem('token');
            window.open(`${process.env.VUE_APP_API}/client/packages/export/excel?status=${this.searchStatus}&start=${this.time[0]}&end=${this.time[1]}&partner=${this.partner}&code=${this.search.code}&phone=${this.search.phone}&token=${token}`);
        }
        hideDiadlong(e:any){
			this.outboundStatus = false
        }
        async nalysisTypeChange(){
			if(this.analysisType === '0'){
                const res = await this.getStockAnalysisData();
                this.stockAnalysisData = res;
			}
			if(this.analysisType === '1'){
			    this.getlegacyAnalysisData();
			}
        }
        playChukuSuccess(){
			const audio = new Audio(require('../../assets/chuku-success.mp3'));
			audio.play();
		}
		playChukuFail(){
			const audio = new Audio(require('../../assets/chuku-fail.mp3'));
			audio.play();
        }
        playRukuFail(){
            const audio = new Audio(require('../../assets/ruku-fail.mp3'));
            audio.play();
        }
        playRuSuccess(){
            const audio = new Audio(require('../../assets/ruku-success.mp3'));
            audio.play();
        }
        // 入站
        async inbound(type:string){
            const res = await this.inboundPachages({
                id: this.lookInfoId,
                type: type
            })
        }
    }
